import { render } from "./ImageFullscreen.vue?vue&type=template&id=131d1dc4"
import script from "./ImageFullscreen.vue?vue&type=script&lang=js"
export * from "./ImageFullscreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__